<template>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="edicaoCabecalho" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ modelo.cdmodelo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome do Modelo</label>
                <input type="text" v-model="modelo.nmmodelo" v-uppercase maxlength="100" />
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption">Ativo</label>
                <select v-model="modelo.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item-char30">
                <label class="label-caption">Tipo Controle</label>
                <select v-model="tipoControle">
                    <option value="G">Grupo de Equipamento</option>
                    <option value="E">Equipamento Específico</option>
                </select>
            </div>

            <div v-if="tipoControle=='E'" class="form-item">
                <EquipamentoFrame :init-id="modelo.idequipamento" v-model:id-selecionado="modelo.idequipamento" />
            </div>

            <div v-else class="form-item">
                <EquipamentoGrupoSelect v-model:id-selecionado="modelo.idequipamentogrupo" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Informações</label>
                <textarea v-model="modelo.informacoes" maxlength="1000" rows="3" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="salvarCabecalho" :disabled="isLoading">
                <span v-if="!isLoading">Salvar Modelo</span>
                <span v-else class="loader"></span>
            </button>
            <button class="btn-cancel" @click="closeForm(false)">Cancelar</button>
        </div>
    </div>


    <div v-else>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Plano</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(modeloSelecionado.cdmodelo) }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome do Modelo</label>
                    <div class="field-label">{{ modeloSelecionado.nmmodelo }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Grupo/Equipamentos</label>
                    <div class="field-label">{{ modeloSelecionado.nmgrupo }}{{ modeloSelecionado.nmequipamento }}</div>
                </div>
            </div>

            <div style="display:flex; gap:10px; flex-wrap:wrap">
                <CardSummarySingle class="form-item" label="Itens" :value="itens.length" />
                <CardSummarySingle class="form-item" label="Itens com opções" :value="totalItensComOpcoes" />
                <CardSummarySingle class="form-item" label="Total de opções" :value="totalOpcoes" />
                <CardSummarySingle class="form-item" label="Status" :value="modelo.ativo === 'S' ? 'Ativo' : 'Inativo'" />
            </div>
        </div>
        

        <div class="form-panel">
            <div class="form-panel-header">ITENS DO MODELO</div>
            <div class="form-panel-body">
                <div class="row-end row-space">
                    <button class="btn-confirm" @click="adicionarItem">+ Adicionar Item</button>
                    <button @click="expandirTodos">Expandir todos</button>
                    <button @click="recolherTodos">Recolher todos</button>
                    <button class="btn-confirm" @click="salvarItensOpcoes" :disabled="isLoading">
                        <span v-if="!isLoading">Salvar Alterações</span>
                        <span v-else class="loader"></span>
                    </button>
                    <button class="btn-cancel" @click="closeForm(false)">Cancelar</button>
                </div>

                <div v-if="itens.length === 0" class="info-empty">Nenhum item adicionado ao modelo!</div>

                <!-- ITENS -->
                <div
                    v-for="(item, index) in itens"
                    :key="item._uid"
                    class="item-card"
                >
                    <div class="item-card-header" @click="item.expandido = !item.expandido">
                        <div class="item-card-left">
                            <span class="expander">{{ item.expandido ? '▾' : '▸' }}</span>
                            <div>
                                <div class="item-card-title">
                                    {{ index + 1 }}. {{ item.nmitem || 'Novo item' }}
                                </div>
                                <div class="item-card-subtitle">
                                    Bloco: {{ item.nmbloco || '-' }} |
                                    Tipo: {{ item.nmtipo_resposta || '-' }} |
                                    Ordem: {{ item.ordem || 0 }} |
                                    Ativo: {{ item.ativo === 'S' ? 'Sim' : 'Não' }}
                                </div>
                            </div>
                        </div>


                      <div class="item-card-actions" @click.stop>
                          <button class="btn-small" @click="moverItem(index, -1)" :disabled="index === 0">↑</button>
                          <button class="btn-small" @click="moverItem(index, 1)" :disabled="index === itens.length - 1">↓</button>
                          <button class="btn-small" @click="duplicarItem(index)">Duplicar</button>
                          <button class="btn-small" @click="removerItem(index)">Remover</button>
                      </div>
                    </div>


                    <div v-show="item.expandido" class="item-card-body">
                        <div class="row row-space">
                            <div class="form-item-char10">
                                <label class="label-caption">Bloco</label>
                                <input type="text" class="input-right" v-number maxlength="3" v-model="item.cdbloco" />
                            </div>

                            <div class="form-item">
                                <label class="label-caption">Nome do Bloco</label>
                                <input type="text" v-model="item.nmbloco" maxlength="100" v-uppercase />
                            </div>
                            
                            <div class="form-item-char10">
                                <label class="label-caption">Ordem</label>
                                <input type="text" class="input-right" v-number maxlength="3" v-model="item.ordem" />
                            </div>
                        </div>


                        <div class="row row-space">
                            <div class="form-item">
                                <label class="label-caption">Nome do Item</label>
                                <input type="text" v-model="item.nmitem" maxlength="100" v-uppercase />
                            </div>
                            
                            <div class="form-item-char40">
                                <label class="label-caption">Tipo de Resposta</label>
                                <select v-model="item.cdtipo_resposta" @change="ajustarTipoResposta(item)">
                                    <option value="B">OK / NOK</option>
                                    <option value="T">Texto</option>
                                    <option value="N">Número</option>
                                    <option value="L">Lista de opções</option>
                                    <option value="M">Múltipla escolha</option>
                                </select>
                            </div>

                            <div class="form-item-char40">
                                <label class="label-caption">Nome Tipo</label>
                                <div class="field-label">{{ item.nmtipo_resposta }}</div>
                            </div>
                        </div>

                        
                        <div class="row row-space">
                            <div class="form-item">
                                <label class="label-caption">Ativo</label>
                                <select v-model="item.ativo">
                                    <option value="S">Sim</option>
                                    <option value="N">Não</option>
                                </select>
                            </div>

                            <div class="form-item">
                                <label class="label-caption">Obrigatório</label>
                                <select v-model="item.ckobrigatorio">
                                    <option value="S">Sim</option>
                                    <option value="N">Não</option>
                                </select>
                            </div>

                            <div class="form-item">
                                <label class="label-caption">NOK exige info</label>
                                <select v-model="item.cknok_exige_informacoes">
                                    <option value="S">Sim</option>
                                    <option value="N">Não</option>
                                </select>
                            </div>
                            
                            <div class="form-item">
                                <label class="label-caption">NOK exige foto</label>
                                <select v-model="item.cknok_exige_foto">
                                    <option value="S">Sim</option>
                                    <option value="N">Não</option>
                                </select>
                            </div>
                        </div>

                        
                        <div class="row row-space">
                            <div class="form-item">
                                <label class="label-caption">Informações do Item</label>
                                <textarea v-model="item.informacoes" maxlength="1000" rows="2" style="resize: none;"
                                    placeholder="Orientações para preenchimento do item..."
                                />
                            </div>
                        </div>


                        <div class="row row-space" v-if="item.cdtipo_resposta === 'N'">
                            <div class="form-item-char30">
                                <label class="label-caption">Valor Mínimo</label>
                                <input v-model="item.vlmin" v-decimal-mask type="text" class="input-right" />
                            </div>

                            <div class="form-item-char30">
                                <label class="label-caption">Valor Máximo</label>
                                <input v-model="item.vlmax" v-decimal-mask type="text" class="input-right" />
                            </div>

                            <div class="form-item">
                                <label class="label-caption">Nome/Unidade</label>
                                <input type="text" v-model="item.nmunidade" maxlength="50" v-uppercase />
                            </div>
                        </div>


                        <!-- OPÇÕES -->
                        <div v-if="usaOpcoes(item)" class="opcoes-box">
                            <div class="section-title small">
                                <h4>Opções do Item</h4>
                                <button @click="adicionarOpcao(item)">+ Adicionar Opção</button>
                            </div>

                            <div
                                v-for="(opcao, opIndex) in item.opcoes"
                                :key="opcao._uid"
                                class="opcao-card"
                            >
                                <div class="row">
                                    <div class="form-item-char10">
                                        <label class="label-caption">Ordem</label>
                                        <input type="text" class="input-right" v-number maxlength="3" v-model="opcao.ordem" />
                                    </div>

                                    <div class="form-item">
                                        <label class="label-caption">Nome da Opção</label>
                                        <input type="text" v-model="opcao.nmopcao" maxlength="100" v-uppercase />
                                    </div>

                                    <div class="form-item-char10">
                                      <label class="label-caption">Ativo</label>
                                      <select v-model="opcao.ativo">
                                        <option value="S">Sim</option>
                                        <option value="N">Não</option>
                                      </select>
                                    </div>

                                    <div class="form-item-char10">
                                        <label class="label-caption">Aprovado</label>
                                        <select v-model="opcao.ckaprovado">
                                            <option value="S">Sim</option>
                                            <option value="N">Não</option>
                                        </select>
                                    </div>

                                    <button class="btn-small" @click="removerOpcao(item, opIndex)">Excluir</button>
                                </div>
                            </div>

                            <div v-if="item.opcoes.length < 2" class="info-empty">
                                Este item precisa de pelo menos 2 (DUAS) opções!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { Api } from '@/funcoes/apiExport'
import { CardSummarySingle } from '@/components/cards'
import { Funcoes } from '@/funcoes/utils'
import { globalStore } from '@/globals'
import { Validar } from '@/funcoes/validacoes'
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue'
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue'

const emit = defineEmits(['close', 'save'])
const props = defineProps({idEdicao: {type: Number, default: 0}})

const edicaoCabecalho = ref(true)
const isLoading = ref(false)
const msgAlerta = ref('')
const tipoControle = ref('G')

const modeloSelecionado = reactive({})

const modelo = reactive({
    id: 0,
    idmunicipio: 0,
    idequipamento: 0,
    idequipamentogrupo: 0,
    cdmodelo: 0,
    nmmodelo: '',
    informacoes: '',
    ativo: 'S',
    idlogin: 0
})


function closeForm(emitSave){
    if (emitSave) emit('save');
    emit('close');
}


async function lerDadosCabecalho(){
    try{
        isLoading.value = true;
        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('checklist_modelo', props.idEdicao);
            Object.assign(modelo, req[0]);
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    }finally{isLoading.value = false;}
}


async function lerDadosItens(){
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        const dados = await Api.genericPost('/listas/checklist_modelo_item', {intparam1: modeloSelecionado.id});
        itens.value = [];
        if (!dados || dados.length === 0) return;

        for (const itemApi of dados){
            const itemLocal = {
                _uid: gerarUid(),
                expandido: false,
                _erroNmitem: false,
                _erroOpcoes: '',
                id: itemApi.id || 0,
                idmodelo: itemApi.idmodelo || 0,
                cdbloco: itemApi.cdbloco || 0,
                nmbloco: itemApi.nmbloco || '',
                ordem: itemApi.ordem || 0,
                nmitem: itemApi.nmitem || '',
                informacoes: itemApi.informacoes || '',
                cdtipo_resposta: itemApi.cdtipo_resposta || 'B',
                nmtipo_resposta: itemApi.nmtipo_resposta || getNomeTipoResposta(itemApi.cdtipo_resposta || 'B'),
                ativo: itemApi.ativo || 'S',
                ckobrigatorio: itemApi.ckobrigatorio || 'N',
                cknok_exige_informacoes: itemApi.cknok_exige_informacoes || 'N',
                cknok_exige_foto: itemApi.cknok_exige_foto || 'N',
                vlmin: itemApi.vlmin || 0,
                vlmax: itemApi.vlmax || 0,
                nmunidade: itemApi.nmunidade || '',
                idlogin: itemApi.idlogin || 0,
                opcoes: []
            };

            if (usaOpcoes(itemLocal)) {
                itemLocal.opcoes = await lerDadosOpcoes(itemLocal.id);
            }

            itens.value.push(itemLocal);
        }
        reordenarItens();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    }finally{isLoading.value = false;}
}


async function lerDadosOpcoes(idModeloItem) {
    try {
        const dados = await Api.genericPost('/listas/checklist_modelo_item_opcao', {
            intparam1: idModeloItem
        });

        if (!dados || dados.length === 0) return [];

        return dados.map((opcao) => ({
            _uid: gerarUid(),
            _erroNmopcao: false,
            id: opcao.id || 0,
            idmodeloitem: opcao.idmodeloitem || idModeloItem,
            ordem: opcao.ordem || 0,
            cdopcao: opcao.cdopcao || '',
            nmopcao: opcao.nmopcao || '',
            vlreferencia: opcao.vlreferencia || 0,
            ativo: opcao.ativo || 'S',
            ckaprovado: opcao.ckaprovado || 'N',
            idlogin: opcao.idlogin || 0
        }));
    } catch (error) {
        console.error('Erro ao ler opções do item:', idModeloItem, error);
        return [];
    }
}


async function salvarCabecalho(){
    msgAlerta.value = validarDadosCabecalho();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;
        modelo.idmunicipio = globalStore.idmunicipio;
        modelo.idlogin = globalStore.idlogin;


        // AJUSTE PARA NÃO PERMITIR DUPLA ATRIBUIÇÃO DO MODELO
        if (tipoControle.value == "E") modelo.idequipamentogrupo = null;
        if (tipoControle.value == "G") modelo.idequipamento = null;


        const response = await Api.genericPut('/cad/checklist_modelo', modelo);
        if (response.bolok === 1){
            emit('save');
            
            const ret = await Api.genericPost('/listas/checklist_modelo', {idmunicipio: globalStore.idmunicipio, id: response.id});
            if (ret.length>0){
                Object.assign(modeloSelecionado, ret[0]);
                edicaoCabecalho.value = false;
                lerDadosItens();
            }
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value = false;}
}


async function salvarItensOpcoes(){
    msgAlerta.value = validarDadosItensOpcoes();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;
        let rItem, rOpcao;
        for (const item of itens.value){
            item.idmodelo = modeloSelecionado.id;
            item.idlogin = globalStore.idlogin;
            item.vlmax = Funcoes.decimalFromString(item.vlmax);
            item.vlmin = Funcoes.decimalFromString(item.vlmin);
            rItem = await Api.genericPut('/cad/checklist_modelo_item', item);
            if (rItem.bolok === 1){
                item.id = rItem.id;
                if (usaOpcoes(item)){
                    for (const opcao of item.opcoes){
                        opcao.idmodeloitem = rItem.id;
                        rOpcao = await Api.genericPut('/cad/checklist_modelo_item_opcao', opcao);
                        if (rOpcao.bolok != 1){
                            msgAlerta.value = rOpcao.erro;
                            isLoading.value = false;
                            return;
                        }else{
                            opcao.id = rOpcao.id;
                        }
                    }
                }
            }else{
                msgAlerta.value = rItem.erro;
                isLoading.value = false;
                return;
            }
        }
        closeForm(true);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value = false;}
}


function validarDadosCabecalho(){
    let r = Validar.texto(modelo.nmmodelo, 'Informe nome do modelo');
    if (!r.ok) return r.msg;
    if (tipoControle.value == 'G' && !modelo.idequipamentogrupo) return 'Informe o Grupo de Equipamento';
    if (tipoControle.value == 'E' && !modelo.idequipamento) return 'Informe o Equipamento';
    return null;
}


function validarDadosItensOpcoes(){
    if (itens.value.length === 0) return "ATENÇÃO: Necessário informar algum ítem para o modelo";
    for (const item of itens.value) {
        if (!item.nmitem || !item.nmitem.trim()) return `O item "${item.ordem}" não possui nome`;
        if (usaOpcoes(item) && item.opcoes.length < 2) return `O item "${item.nmitem}" precisa ter pelo menos 2 (duas) opções`;
        if (usaOpcoes(item)){
            for (const opcao of item.opcoes){
                if (!opcao.nmopcao || !opcao.nmopcao.trim()) return `Há opções sem descrição no item "${item.nmitem}".`;
            }
        }
    }
    return null;
}

const itens = ref([])

function gerarUid() {
    return `${Date.now()}_${Math.random().toString(16).slice(2)}`
}

function getNomeTipoResposta(cd) {
    switch (cd) {
        case 'B': return 'OK/NOK'
        case 'T': return 'TEXTO'
        case 'N': return 'NÚMERO'
        case 'L': return 'LISTA OPÇÕES'
        case 'M': return 'MÚLTIPLA ESCOLHA'
        default: return ''
    }
}

function novoItem(ordem = 1) {
    const tipo = 'B'
    return {
        _uid: gerarUid(),
        expandido: true,
        _erroNmitem: false,
        _erroOpcoes: '',
        id: 0,
        idmodelo: 0,
        cdbloco: 0,
        nmbloco: '',
        ordem,
        nmitem: '',
        informacoes: '',
        cdtipo_resposta: tipo,
        nmtipo_resposta: getNomeTipoResposta(tipo),
        ativo: 'S',
        ckobrigatorio: 'S',
        cknok_exige_informacoes: 'N',
        cknok_exige_foto: 'N',
        vlmin: 0,
        vlmax: 0,
        nmunidade: '',
        idlogin: 0,
        opcoes: []
    }
}

function novaOpcao(ordem = 1) {
    return {
        _uid: gerarUid(),
        _erroNmopcao: false,
        id: 0,
        idmodeloitem: 0,
        ordem,
        cdopcao: '',
        nmopcao: '',
        vlreferencia: 0,
        ativo: 'S',
        ckaprovado: 'N',
        idlogin: 0
    }
}

function usaOpcoes(item) {
    return item.cdtipo_resposta === 'L' || item.cdtipo_resposta === 'M'
}


function adicionarItem() {
    const ordem = itens.value.length + 1
    itens.value.push(novoItem(ordem))
}


function duplicarItem(index) {
    const original = itens.value[index]
    const copia = {
      ...JSON.parse(JSON.stringify(original)),
      _uid: gerarUid(),
      expandido: true,
      id: 0,
      nmitem: `${original.nmitem || 'Novo item'} (cópia)`,
      opcoes: original.opcoes.map((opcao) => ({
        ...JSON.parse(JSON.stringify(opcao)),
        _uid: gerarUid(),
        id: 0,
        idmodeloitem: 0
      }))
    }

    itens.value.splice(index + 1, 0, copia)
    reordenarItens()
}


function removerItem(index) {
    itens.value.splice(index, 1)
    reordenarItens()
}


function moverItem(index, direcao) {
    const novoIndex = index + direcao
    if (novoIndex < 0 || novoIndex >= itens.value.length) return

    const item = itens.value[index]
    itens.value.splice(index, 1)
    itens.value.splice(novoIndex, 0, item)
    reordenarItens()
}


function reordenarItens() {
    itens.value.forEach((item, idx) => {
      item.ordem = idx + 1
    })
}


function ajustarTipoResposta(item) {
    item.nmtipo_resposta = getNomeTipoResposta(item.cdtipo_resposta)

    if (item.cdtipo_resposta !== 'N') {
      item.vlmin = 0
      item.vlmax = 0
      item.nmunidade = ''
    }

    if (!usaOpcoes(item)) {
      item.opcoes = []
      item._erroOpcoes = ''
    } else if (item.opcoes.length === 0) {
      item.opcoes.push(novaOpcao(1))
    }
}


function adicionarOpcao(item) {
    const ordem = item.opcoes.length + 1
    item.opcoes.push(novaOpcao(ordem))
}


function removerOpcao(item, index) {
    item.opcoes.splice(index, 1)
    reordenarOpcoes(item)
}


function reordenarOpcoes(item) {
    item.opcoes.forEach((opcao, idx) => {
      opcao.ordem = idx + 1
    })
}


function expandirTodos() {
    itens.value.forEach((item) => {
      item.expandido = true
    })
}


function recolherTodos() {
    itens.value.forEach((item) => {
      item.expandido = false
    })
}


const totalItensComOpcoes = computed(() =>
    itens.value.filter((item) => usaOpcoes(item)).length
)


const totalOpcoes = computed(() =>
    itens.value.reduce((total, item) => total + item.opcoes.length, 0)
)


onMounted(lerDadosCabecalho)
</script>

<style scoped>
.section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

.section-title.small {
    margin-bottom: 10px;
}

.item-card {
    border: 1px solid #d9e2ec;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 14px;
    background: #f8fafc;
}

.item-card-header {
    padding: 14px 16px;
    background: #eef4fa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    cursor: pointer;
}

.item-card-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.expander {
    font-size: 16px;
    color: #334155;
    width: 18px;
    text-align: center;
}

.item-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
}

.item-card-subtitle {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
}

.item-card-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.item-card-body {
    padding: 14px 16px;
}

.opcoes-box {
    margin-top: 14px;
    border: 1px dashed #c8d4e0;
    border-radius: 10px;
    padding: 12px;
    background: #ffffff;
}

.opcao-card {
    border: 1px solid #e6edf5;
    border-radius: 10px;
    padding: 12px;
    margin-top: 10px;
    background: #fafcff;
}
</style>